import z from "zod";

export const addressBookDataSchema = z.object({
  disabled: z.coerce.boolean().optional(),
});

export type AddressBookDataProps = z.infer<typeof addressBookDataSchema>;
